<template>
    <div>
        <v-col v-if="cartItems && cartItems.length">
            <v-card
                elevation="0"
                class="mb-4"
                color="white"
                tile
                v-for="(cartItem, index) in cartItems.slice().reverse()"
                v-bind:key="index"
            >
                <v-row class="mx-1">
                    <v-col cols="5" sm="4" md="4" lg="4" class="pt-3">
                        <div
                            v-if="
                                productCustomAttributes(cartItem?.product)
                                    .is_personalize == 1
                            "
                        >
                            <div
                                v-if="
                                    builderSession(
                                        cartItem?.customizableOptions,
                                    ) && cartItem?.thumbnailUrl
                                "
                            >
                                <div
                                    v-for="(
                                        item, itemIndex
                                    ) in cartItem?.thumbnailUrl"
                                    :key="itemIndex"
                                    class="mb-2"
                                >
                                    <v-img
                                        v-bind:src="
                                            item
                                                ? item
                                                : cartItem?.product?.thumbnail
                                                      ?.url
                                        "
                                    ></v-img>
                                </div>
                            </div>

                            <div
                                v-else-if="
                                    isDesignProject(
                                        cartItem?.customizableOptions,
                                    ) && cartItem?.builderSessionItemList
                                "
                            >
                                <div
                                    v-for="(
                                        item, itemIndex
                                    ) in cartItem?.builderSessionItemList"
                                    :key="itemIndex"
                                    class="mb-2"
                                >
                                    <v-img
                                        v-bind:src="item.thumbnailUrl"
                                    ></v-img>
                                </div>
                            </div>
                            <div v-else>
                                <v-img
                                    v-bind:src="
                                        imageBasePathUrl +
                                        productCustomAttributes(
                                            cartItem?.product,
                                        )?.image
                                    "
                                ></v-img>
                            </div>
                        </div>
                        <div v-else>
                            <v-img
                                v-bind:src="
                                    imageBasePathUrl +
                                    productCustomAttributes(cartItem?.product)
                                        ?.image
                                "
                            ></v-img>
                        </div>
                    </v-col>

                    <v-col cols="7" v-show="!cartProductPage" class="pb-0 my-0">
                        <v-row class="ma-0">
                            <v-col class="px-0 pt-2 pb-2 ma-0">
                                <p
                                    class="fontsize-14 text-black text-left cursor-pointer"
                                    @click="
                                        goToProductDetails(
                                            productCustomAttributes(
                                                cartItem?.product,
                                            ),
                                            cartItem?.product?.name,
                                            cartItem?._typename,
                                        )
                                    "
                                >
                                    {{ cartItem?.product?.name }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-expansion-panels
                            class="pa-0 mt-n3 active-panel-edited"
                            v-show="
                                cartItem?._typename == 'ConfigurableCartItem' ||
                                cartItem?._typename == 'GiftCardCartItem'
                            "
                        >
                            <v-expansion-panel
                                elevation="0"
                                class="pa-0 ma-0"
                                v-if="
                                    cartItem?.productOption ||
                                    cartItem?.configurableOptions?.length > 0 ||
                                    cartItem?._typename === 'GiftCardCartItem'
                                "
                            >
                                <v-expansion-panel-title class="pa-0 ma-0"
                                    >See Details</v-expansion-panel-title
                                >
                                <v-expansion-panel-text
                                    v-if="
                                        cartItem?._typename ==
                                        'GiftCardCartItem'
                                    "
                                    class="cartproductlist-expansion"
                                >
                                    <p
                                        class="font-weight-bold fontsize-14 text-black text-left cursor-pointer mb-1"
                                    >
                                        Gift Card Sender
                                    </p>
                                    <br />
                                    <p
                                        v-if="
                                            cartItem?.productOption
                                                ?.infoBuyRequest ||
                                            cartItem?.senderName
                                        "
                                        class="fontsize-14 text-black text-left cursor-pointer"
                                    >
                                        {{
                                            cartItem?.productOption
                                                ?.infoBuyRequest
                                                ?.giftcardSenderName ??
                                            cartItem?.senderName
                                        }}
                                        <br />
                                        {{
                                            cartItem?.productOption
                                                ?.infoBuyRequest
                                                ?.giftcardSenderEmail ??
                                            cartItem?.senderEmail
                                        }}
                                    </p>
                                    <br />
                                    <p
                                        class="font-weight-bold fontsize-14 text-black text-left cursor-pointer mb-1"
                                    >
                                        Gift Card Recipient
                                    </p>
                                    <br />
                                    <p
                                        v-if="
                                            cartItem?.productOption
                                                ?.infoBuyRequest ||
                                            cartItem?.recipientName
                                        "
                                        class="fontsize-14 text-black text-left cursor-pointer"
                                    >
                                        {{
                                            cartItem?.productOption
                                                ?.infoBuyRequest
                                                ?.giftcardRecipientName ??
                                            cartItem?.recipientName
                                        }}
                                        <br />
                                        {{
                                            cartItem?.productOption
                                                ?.infoBuyRequest
                                                ?.giftcardRecipientEmail ??
                                            cartItem?.recipientEmail
                                        }}
                                    </p>
                                </v-expansion-panel-text>
                                <v-expansion-panel-text
                                    v-else
                                    class="cartproductlist-expansion"
                                >
                                    <p
                                        class="font-weight-bold fontsize-14 text-black text-left cursor-pointer mb-1"
                                    >
                                        Option
                                    </p>
                                    <p
                                        v-if="
                                            cartItem?.productOption
                                                ?.attributesInfo?.length > 0
                                        "
                                        class="fontsize-14 text-black cursor-pointer"
                                    >
                                        {{
                                            cartItem?.productOption
                                                ?.attributesInfo[0]?.value
                                        }}
                                    </p>
                                    <p
                                        v-if="
                                            cartItem?.configurableOptions
                                                ?.length > 0
                                        "
                                        class="fontsize-14 text-black cursor-pointer"
                                    >
                                        {{
                                            cartItem?.configurableOptions[0]
                                                ?.valueLabel
                                        }}
                                    </p>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <p class="fontsize-14 text-left">
                            ${{
                                priceFormatter(cartItem?.prices?.price?.value)
                            }}
                        </p>

                        <div v-if="pageName() != 'CheckoutPage'">
                            <v-row
                                v-if="
                                    productCustomAttributes(cartItem?.product)
                                        .is_personalize == 1
                                "
                                align="center"
                                class="mt-0"
                            >
                                <v-col cols="auto" class="pr-1 pt-0">
                                    <p class="fontsize-14 mb-0 pb-7">Qty.</p>
                                </v-col>
                                <v-col class="pl-0 pt-0">
                                    <v-hover v-slot="{ isHovering, props }">
                                        <v-select
                                            :items="
                                                qtyPriceOptions(
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    )?.qty_price ?? 0,
                                                    cartItem?.quantity,
                                                    index,
                                                )
                                            "
                                            class="fontsize-16 line-height-21 ls-n009 font-weight-400 changeOnHover cartproductlist-select-button seTextBoxWidth"
                                            variant="outlined"
                                            density="compact"
                                            v-bind="props"
                                            attach
                                            :class="
                                                isHovering
                                                    ? 'text-primary'
                                                    : 'text-black'
                                            "
                                            v-model="selectedQty[index]"
                                            @update:modelValue="
                                                updateToCart(
                                                    cartItem?.product?.name,
                                                    cartItem?.product?.sku,
                                                    cartItem?.uid,
                                                    index,
                                                    cartItem?.prices?.price
                                                        ?.value,
                                                    cartItem?.personalizeDetails,
                                                    getProductOptionValueUidPart(
                                                        cartItem,
                                                        index,
                                                    ).optionId,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).letter ??
                                                        getProductOptionValueUidPart(
                                                            cartItem,
                                                            index,
                                                        ).letter,
                                                    cartItem?._typename,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).is_personalize,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).builder_version,
                                                    cartItem?.ccid,
                                                    cartItem?.product?.sku,
                                                    cartItem,
                                                    $event,
                                                )
                                            "
                                            :model-value="selectedQty[index]"
                                            ref="selectedCartQty4"
                                            append-inner-icon="mdi-plus"
                                            item-value="qty"
                                            item-title="qty"
                                            item-children="qty"
                                        ></v-select>
                                    </v-hover>
                                </v-col>
                            </v-row>
                            <v-row align="center" v-else class="my-0 pb-0">
                                <v-col cols="auto" class="pr-1 py-0">
                                    <p class="fontsize-14 mb-0 pb-7">Qty.</p>
                                </v-col>
                                <v-col class="pl-0 pb-0 mb-0">
                                    <v-hover v-slot="{ isHovering, props }">
                                        <v-select
                                            :items="
                                                numberOptions(
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    )?.ba_min_sales_qty,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    )?.ba_qty_increments,
                                                    cartItem?.quantity,
                                                    index,
                                                )
                                            "
                                            class="word-break fontsize-14 line-height-21 ls-n009 font-weight-400 cartproductlist-select-button select-change-icon seTextBoxWidth"
                                            :class="
                                                isHovering
                                                    ? 'text-primary'
                                                    : 'text-black'
                                            "
                                            single-line
                                            v-model="selectedQty[index]"
                                            :model-value="selectedQty[index]"
                                            @update:modelValue="
                                                updateToCart(
                                                    cartItem?.product?.name,
                                                    cartItem?.product?.sku,
                                                    cartItem?.uid,
                                                    index,
                                                    cartItem?.prices?.price
                                                        ?.value,
                                                    cartItem?.personalizeDetails,
                                                    getProductOptionValueUidPart(
                                                        cartItem,
                                                        index,
                                                    ).optionId,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).letter ??
                                                        getProductOptionValueUidPart(
                                                            cartItem,
                                                            index,
                                                        ).letter,
                                                    cartItem?._typename,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).is_personalize,
                                                    productCustomAttributes(
                                                        cartItem?.product,
                                                    ).builder_version,
                                                    cartItem?.ccid,
                                                    cartItem?.product?.sku,
                                                    cartItem?.product,
                                                    $event,
                                                )
                                            "
                                            :menu-props="{
                                                auto: true,
                                                overflowY: false,
                                                zIndex: 9999,
                                                backgroundColor: `#fff`,
                                            }"
                                            ref="selectedCartQty2"
                                            append-inner-icon="mdi-plus"
                                            v-bind="props"
                                            density="compact"
                                            variant="outlined"
                                        ></v-select>
                                    </v-hover>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else>
                            <v-row class="pt-5 pb-10">
                                <v-col cols="auto" class="py-0 pr-0">
                                    <p class="fontsize-14 mb-1">Qty.</p>
                                </v-col>
                                <v-col cols="auto" class="py-0 pl-2">
                                    <p class="fontsize-14 text-black">
                                        {{ cartItem?.quantity }}
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-row class="ma-0 pb-0 pt-0" v-show="checkOut">
                        <v-col align="right">
                            <span v-if="!hasDesignProjectId(cartItem)">
                                <a
                                    class="fontsize-14 text-black text-uppercase cartproductlist-action-link cursor-pointer"
                                    @click.stop="
                                        editProduct(
                                            cartItem?.product?.name,
                                            cartItem?.product?.sku,
                                            cartItem?.uid,
                                            index,
                                            productCustomAttributes(
                                                cartItem?.product,
                                            ).is_personalize,
                                            productCustomAttributes(
                                                cartItem?.product,
                                            ).builder_version,
                                            cartItem?.ccid,
                                            cartItem?._typename,
                                            cartItem?.product?.sku,
                                            cartItem,
                                        )
                                    "
                                    >Edit</a
                                >
                                <span class="px-1">|</span></span
                            >

                            <a
                                class="fontsize-14 text-black text-uppercase cartproductlist-action-link cursor-pointer"
                                @click.stop="
                                    remove(
                                        cartItem?.product?.sku,
                                        cartItem?.uid,
                                        index,
                                        productCustomAttributes(
                                            cartItem?.product,
                                        ).builder_version,
                                        cartItem,
                                    )
                                "
                                >Remove</a
                            >
                            <span
                                v-if="
                                    builderSession(
                                        cartItem?.customizableOptions,
                                    )
                                "
                            >
                                <span class="px-1">|</span>
                                <a
                                    class="fontsize-14 text-black text-uppercase cartproductlist-action-link cursor-pointer"
                                    @click.stop="saveForLater(cartItem)"
                                    >Save for later
                                </a>
                            </span>
                        </v-col>
                        <div class="myDivider mb-4"></div>
                    </v-row>
                </v-row>
                <v-row> </v-row>
            </v-card>
            <v-col class="text-center mb-12" v-if="isGateModulePage">
                <router-link
                    class="text-decoration-none cartproductlist-link border-left-none"
                    @click="closeDrawer()"
                    >View and edit cart</router-link
                >
            </v-col>
            <v-col
                v-else
                class="text-center mb-12"
                v-show="
                    pageName() !== 'CartProducts' &&
                    pageName() !== 'CheckoutPage'
                "
            >
                <v-hover v-slot:default="{ hover }">
                    <router-link
                        :class="
                            hover ? 'content-link-hover-color' : 'text-primary'
                        "
                        class="text-decoration-none cartproductlist-link"
                        to
                        @click="closeDrawer()"
                        >View and edit cart</router-link
                    >
                </v-hover>
            </v-col>
        </v-col>

        <v-dialog
            v-model="confirmationDialogFlag"
            origin="left top"
            hide-overlay
            persistent
            max-width="800px"
        >
            <v-card tile flat>
                <v-card-title class="pb-0">
                    <v-row no-gutters>
                        <v-col cols="11">
                            <p
                                class="body mt-1 mb-3 fontcolor-black-light delete-title-font"
                            >
                                Are you sure you would like to remove this item
                                from the shopping cart?
                            </p>
                        </v-col>
                        <v-col cols="1" class="text-right">
                            <router-link
                                to
                                class="text-decoration-none black--text fontcolor-black-light"
                            >
                                <div @click="confirmationDialogFlag = false">
                                    X
                                </div>
                            </router-link>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-actions class="px-4 pt-0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-btn
                                class="text-uppercase ma-2"
                                color="primary"
                                variant="flat"
                                rounded="0"
                                @click="confirmationDialogFlag = false"
                                >CANCEL</v-btn
                            >
                            <v-btn
                                class="text-uppercase ma-2"
                                color="error"
                                variant="flat"
                                rounded="0"
                                @click="removeProduct(true)"
                            >
                                OK
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Sign In Form -->
        <v-dialog v-model="signInForm" persistent flat max-width="500">
            <v-card flat>
                <v-card-title class="d-flex justify-space-between">
                    <p class="h3 mb-0 whyte-regular-font">Sign In</p>
                    <v-btn
                        @click="closeSignInForm()"
                        density="comfortable"
                        variant="text"
                        :ripple="false"
                        icon
                    >
                        <!-- <v-icon>mdi-window-close</v-icon> -->
                        <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3 pb-0">
                    <v-alert
                        class="word-break"
                        type="error"
                        v-if="!!errorMessage"
                        >{{ errorMessage }}</v-alert
                    >
                    <v-alert
                        class="word-break"
                        type="success"
                        v-if="!!signInMessage"
                        >{{ signInMessage }}</v-alert
                    >
                    <v-form ref="loginForm" v-model="validLogin">
                        <v-col class="pt-3 pb-1">
                            <v-text-field
                                v-model="emailLogin"
                                type="email"
                                label="Email Address"
                                ref="email"
                                name="email"
                                variant="outlined"
                                density="comfortable"
                                :rules="emailRules"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-1 pb-0">
                            <v-text-field
                                v-model="passwordLogin"
                                label="Password"
                                ref="password"
                                type="password"
                                name="password"
                                variant="outlined"
                                density="comfortable"
                                :rules="passwordRules"
                            ></v-text-field>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="12" class="px-7">
                            <v-btn
                                variant="flat"
                                block
                                color="primary"
                                class="text-white"
                                @click="signIn()"
                                :disabled="inProgress || signInProgress"
                            >
                                <v-progress-circular
                                    :size="20"
                                    color="white"
                                    indeterminate
                                    v-if="inProgress"
                                ></v-progress-circular>
                                &nbsp;SIGN IN
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="py-5 pl-7" align="left">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="openSignUpDialog()"
                                >Sign Up</span
                            >
                        </v-col>
                        <v-col cols="6" class="py-5 pr-7" align="right">
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Sign Up -->
        <v-dialog v-model="signUpForm" persistent flat max-width="500">
            <v-card flat>
                <v-card-title class="d-flex justify-space-between">
                    <p class="h3 mb-0 whyte-regular-font">Sign Up</p>
                    <v-btn
                        @click="closeSignUpForm()"
                        density="comfortable"
                        variant="text"
                        :ripple="false"
                        icon
                    >
                        <!-- <v-icon>mdi-window-close</v-icon> -->
                        <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3 pb-0">
                    <v-alert
                        class="word-break"
                        type="error"
                        v-if="!!errorMessage"
                        >{{ errorMessage }}</v-alert
                    >
                    <v-alert
                        class="word-break"
                        type="success"
                        v-if="!!signUpMessage"
                        >{{ signUpMessage }}</v-alert
                    >
                    <v-form
                        ref="signUpForm"
                        id="signup-form"
                        @submit.prevent="signUp"
                    >
                        <v-text-field
                            class="pt-2"
                            label="First Name"
                            type="text"
                            ref="firstName"
                            name="firstName"
                            variant="outlined"
                            density="comfortable"
                            v-model="firstname"
                            :rules="firstNameRules"
                        ></v-text-field>
                        <v-text-field
                            class="pt-2"
                            label="Last Name"
                            type="text"
                            ref="lastName"
                            name="lastName"
                            variant="outlined"
                            density="comfortable"
                            v-model="lastname"
                            :rules="lastNameRules"
                        ></v-text-field>

                        <v-text-field
                            class="pt-2"
                            label="Email Id"
                            type="email"
                            ref="email"
                            name="email"
                            id="userEmail"
                            variant="outlined"
                            density="comfortable"
                            v-model="email"
                            :rules="signUpEmailRules"
                        ></v-text-field>

                        <v-text-field
                            class="pt-2 mt-0"
                            type="password"
                            label="Password"
                            ref="password"
                            name="password"
                            variant="outlined"
                            density="comfortable"
                            v-model="password"
                            :rules="commonValidationRules.passwordRule"
                        ></v-text-field>
                        <v-checkbox
                            v-model="newsletter"
                            label="Subscribe to our newsletter"
                            hide-details="true"
                            color="indigo"
                        ></v-checkbox>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="12" class="px-7">
                            <v-btn
                                variant="flat"
                                block
                                color="primary"
                                class="text-white"
                                @click="signUp(cartItem)"
                                :disabled="inProgress"
                            >
                                <v-progress-circular
                                    :size="20"
                                    color="white"
                                    indeterminate
                                    v-if="inProgress"
                                ></v-progress-circular>
                                &nbsp;SIGN UP
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="py-5 pl-7" align="left">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="openSignInDialog()"
                                >Sign In</span
                            >
                        </v-col>
                        <v-col cols="6" class="py-5 pr-7" align="right">
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
const storeFrontUrl = import.meta.env.VITE_APP_CRANE_DAILY_URL;
const personlizeUrl = import.meta.env.VITE_APP_PERSONALIZE_URL;
const retailorId = import.meta.env.VITE_APP_RETAILOR_ID;
import {
    getLable,
    customAttributeValue,
    priceFormatter,
    checkPromotion,
    getSessionItemProcessesAndLiner,
    googleAanalyticsEventRemoveCart,
    googleAanalyticsEventSaveForLatter,
    commonValidationRules,
    handleBeforeUnload,
    isoStringToNormalDate,
    sendAppcuesEvent,
    getFinalPrice,
    getCurrentItemStructure,
    getSessionItemCombinedElements,
    getFirstColorElement,
    assignColorAndPrint,
    getElementWithHighestColorAddon,
    getAllPrintableElements,
    getCurrentItemDeltaStructure,
} from "@/services/util.service";
import { doFetchProductTags } from "@/services/product.service";
import {
    pricerFieldsIdx,
    pricerFiles,
    priceProduct,
} from "@cranestationery/crane-pricer";

import { getDomain } from "@/services/auth";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

import { createHelpers } from "vuex-map-fields";
const { mapFields: mapFieldsAuth } = createHelpers({
    getterType: "auth/getField",
    mutationType: "auth/updateField",
});
const { mapFields: registerInfo } = createHelpers({
    getterType: "registration/getField",
    mutationType: "registration/updateField",
});
export default {
    name: "CartProductList",
    props: ["cartProductPage", "checkOut"],
    data: () => ({
        commonValidationRules,
        priceFormatter: priceFormatter,
        isActive: true,
        selectedQty: [],
        selectedQtyPersonalize: "",
        retailorId: "08c43bbf-3735-4621-85f9-d71dc2cfb41b",
        itemNumber: "193C",
        quantity: "25",
        savFromKey: "Ub07GxNhS3yyoDfO",
        ccId: "766a5cef-6b51-4ab4-9f25-6446c4c8baeb",
        confirmationDialogFlag: false,
        confirmation: {
            confirmationMessage: "",
        },
        blue: "primary",
        white: "white",
        dialog: false,
        productId: "",
        currentProduct: null,
        removeSessionId: "",
        userQty: 0,
        productBuilderVersion: "",
        productDetails: "",

        signUpForm: false,
        signInForm: false,
        valid: true,
        validLogin: false,
        lazy: false,
        firstNameRules: [
            (v) => !!v || "First Name is required",
            (v) =>
                (v && v.length >= 3) ||
                "First Name must be at least 3 characters",
        ],
        lastNameRules: [
            (v) => !!v || "Last Name is required",
            (v) =>
                (v && v.length >= 3) ||
                "Last Name must be at least 3 characters",
        ],
        signUpEmailRules: [
            (v) => !!v || "Email Id is required",
            (v) => /.+@.+\..+/.test(v) || "Email Id must be valid",
        ],
    }),
    computed: {
        ...mapFieldsAuth({
            oneLogin: "one",
            emailLogin: "one.email",
            passwordLogin: "one.password",
            errorMessage: "errorMessage",
            inProgress: "inProgress",
            signInMessage: "signInMessage",
        }),
        ...registerInfo([
            "one",
            "one.firstname",
            "one.lastname",
            "one.newsletter",
            "one.email",
            "one.password",
            "signUpMessage",
        ]),
        builderSessionId: function () {
            return this.$route.params.sessionId;
        },
        sessionOneDetails: function () {
            return this.$store.state.sessionOne.cartSessionOne;
        },
        cartItems() {
            if (this.userAuth) {
                return this.$store.state.userCartProduct.cartProductList;
            } else {
                return this.$store.state.cartProduct.cartProductList;
            }
        },
        imageBasePathUrl() {
            return import.meta.env.VITE_APP_IMAGE_PATH_URL;
        },
        userAuth: function () {
            return this.$store.state.auth.userAuth;
        },
        guestQuoteId: function () {
            return this.$store.state.guestInfo.guestQuoteId;
        },
        cartId: function () {
            return this.$route.params.designerMode;
        },
        cartItemEdit: function () {
            if (this.cartId && this.cartId !== "true") return true;
            return false;
        },
        /*productAttributes: function() {
      return this.$store.state.productOne.productAttributes;
    },*/
        productAttributes() {
            return this.$store.state.productList.attributeList.items;
        },
        isGateModulePage: function () {
            let pagePath = this.$route.path;
            let isGateModulePage = pagePath.includes("/gate/");
            if (isGateModulePage) return true;

            return false;
        },
        cartProductsProgress: function () {
            if (this.userAuth) {
                return this.$store.state.userCartProduct.cartProductsProgress;
            } else {
                return this.$store.state.cartProduct.cartProductsProgress;
            }
        },
        fetchPriceInProgress: function () {
            return this.$store.state.productOne.fetchPriceInProgress;
        },
        basicInfo() {
            return this.$store.state.accountOne.one;
        },
    },
    methods: {
        getProductOptionValueUidPart(cartItem, index) {
            let encoded = cartItem?.configurableOptions ?? [];
            encoded =
                encoded.length > 0
                    ? encoded[0]?.configurableProductOptionValueUid
                    : "";
            if (!encoded) return { optionId: null, letter: null };

            try {
                const decoded = atob(encoded); // Browser's base64 decode
                const parts = decoded.split("/");
                return {
                    optionId: parts[1] || null,
                    letter: parts[2] || null,
                };
            } catch (e) {
                console.error("Invalid base64:", encoded);
                return { optionId: null, letter: null };
            }
        },
        productCustomAttributes(product) {
            if (!product?.customAttributesV2?.items) return {};
            return product.customAttributesV2.items.reduce((acc, attr) => {
                acc[attr.code] = attr.value;
                return acc;
            }, {});
        },
        hasDesignProjectId(product) {
            const opts = product?.customizableOptions;
            if (Array.isArray(opts)) {
                return opts.some((opt) => opt.label === "DESIGN_PROJECT_ID");
            }
            return false;
        },
        async saveForLater(product) {
            try {
                let builderSessionOne = null;
                this.currentProduct = product;
                this.cartProductsProgress = true;
                if (this.userAuth) {
                    if (
                        product &&
                        product.customizableOptions &&
                        product.customizableOptions.length > 0
                    ) {
                        let optionsList = product.customizableOptions;
                        builderSessionOne = optionsList.find(
                            (x) => x.label == "BuilderSessionId",
                        );
                        if (builderSessionOne) {
                            let sessionId = builderSessionOne.optionValue;
                            if (sessionId) {
                                let resp = await this.$store.dispatch(
                                    "sessionOne/updateOneForCart",
                                    {
                                        sessionId: sessionId,
                                        property: {
                                            orderState: null,
                                            quoteData: null,
                                            state: "saved",
                                        },
                                    },
                                );

                                if (resp && resp.response && window) {
                                    let currentSessionDetails = resp.response;
                                    window.DD_RUM.onReady(function () {
                                        window.DD_RUM.addAction(
                                            "studio_session",
                                            {
                                                session_id: sessionId,
                                                session_state: "save",
                                                sku: currentSessionDetails
                                                    .productData.sku,
                                            },
                                        );
                                    });
                                }

                                await this.$store.dispatch(
                                    "userCartProduct/removeCartProduct",
                                    {
                                        productId: product.itemId,
                                    },
                                );
                                googleAanalyticsEventRemoveCart(
                                    "remove_from_cart",
                                    product,
                                );
                                googleAanalyticsEventSaveForLatter(
                                    product,
                                    "saved_for_later",
                                );

                                this.snackbar = {
                                    message:
                                        "Product Added Successfully in Saved For Later",
                                    color: "success",
                                    show: true,
                                    timeout: 3000,
                                };
                                this.$emit("actionClose", this.snackbar);
                                window.location.reload();
                            }
                        }
                    }
                } else {
                    this.signInForm = true;
                }
            } catch (error) {
                console.error("Error occured : ", error);
                this.$snotify.error(error.message, {
                    position: "rightTop",
                    showProgressBar: false,
                });
            }
        },
        async signIn() {
            try {
                this.cartProductsProgress = true;
                this.inProgress = true;
                const { valid } = await this.$refs.loginForm.validate();
                if (valid) {
                    this.$store.dispatch("auth/changeRedirectFlag", false);
                    let status = await this.$store.dispatch("auth/login");
                    if (status) {
                        this.$store.dispatch("auth/changeRedirectFlag", true);
                        await this.$store.dispatch("accountOne/basicInfo");
                        let builderSessionOne = null;
                        if (
                            this.currentProduct &&
                            this.currentProduct.options &&
                            this.currentProduct.options.options &&
                            this.currentProduct.options.options.length > 0
                        ) {
                            let optionsList =
                                this.currentProduct.options.options;
                            builderSessionOne = optionsList.find(
                                (x) =>
                                    x &&
                                    x.label &&
                                    x.label.toLowerCase() == "buildersessionid",
                            );

                            if (builderSessionOne) {
                                await this.$store.dispatch(
                                    "userCartProduct/cartProductList",
                                    builderSessionOne.optionValue,
                                );
                                if (this.basicInfo) {
                                    let resp = await this.$store.dispatch(
                                        "sessionOne/updateOneForCart",
                                        {
                                            sessionId:
                                                builderSessionOne.optionValue,
                                            property: {
                                                state: "saved",
                                                orderState: null,
                                                quoteData: null,
                                                userData: {
                                                    customer_id:
                                                        this.basicInfo.id,
                                                    customer_name:
                                                        this.basicInfo
                                                            .firstname,
                                                },
                                            },
                                        },
                                    );
                                    if (resp && resp.response && window) {
                                        let currentSessionDetails =
                                            resp.response;
                                        window.DD_RUM.onReady(function () {
                                            window.DD_RUM.addAction(
                                                "studio_session",
                                                {
                                                    session_id:
                                                        builderSessionOne.optionValue,
                                                    session_state: "save",
                                                    sku: currentSessionDetails
                                                        .productData.sku,
                                                    // 'price': priceFormatter(currentSessionDetails.quoteData.qty*currentSessionDetails.quoteData.price),
                                                },
                                            );
                                        });
                                    }
                                    googleAanalyticsEventSaveForLatter(
                                        this.currentProduct,
                                        "saved_for_later",
                                    );
                                }

                                this.signInForm = false;
                                window.location.reload();
                            }
                        }
                    }
                    this.inProgress = false;
                }
                this.cartProductsProgress = false;
                this.inProgress = false;
            } catch (err) {
                this.cartProductsProgress = false;
                this.inProgress = false;
                console.error(err);
                this.$snotify.error(err.message, {
                    position: "rightTop",
                    showProgressBar: false,
                });
            }
        },
        async signUp() {
            try {
                const { valid } = await this.$refs.signUpForm.validate();
                if (valid) {
                    try {
                        this.$store.dispatch("auth/changeRedirectFlag", false);
                        let status = await this.$store.dispatch(
                            "registration/signUp",
                        );
                        if (status) {
                            this.$store.dispatch(
                                "auth/changeRedirectFlag",
                                false,
                            );
                            await this.$store.dispatch("accountOne/basicInfo");
                            let builderSessionOne = null;
                            if (
                                this.currentProduct &&
                                this.currentProduct.options &&
                                this.currentProduct.options.options &&
                                this.currentProduct.options.options.length > 0
                            ) {
                                let optionsList =
                                    this.currentProduct.options.options;
                                builderSessionOne = optionsList.find(
                                    (x) =>
                                        x &&
                                        x.label &&
                                        x.label.toLowerCase() ==
                                            "buildersessionid",
                                );
                                if (builderSessionOne) {
                                    await this.$store.dispatch(
                                        "userCartProduct/cartProductList",
                                        builderSessionOne.optionValue,
                                    );
                                    if (this.basicInfo) {
                                        let resp = await this.$store.dispatch(
                                            "sessionOne/updateOneForCart",
                                            {
                                                sessionId:
                                                    builderSessionOne.optionValue,
                                                property: {
                                                    state: "saved",
                                                    orderState: null,
                                                    quoteData: null,
                                                    userData: {
                                                        customer_id:
                                                            this.basicInfo.id,
                                                        customer_name:
                                                            this.basicInfo
                                                                .firstname,
                                                    },
                                                },
                                            },
                                        );
                                        if (resp && resp.response && window) {
                                            let currentSessionDetails =
                                                resp.response;
                                            window.DD_RUM.onReady(function () {
                                                window.DD_RUM.addAction(
                                                    "studio_session",
                                                    {
                                                        session_id:
                                                            currentSessionDetails.id,
                                                        session_state: "save",
                                                        sku: currentSessionDetails
                                                            .productData.sku,
                                                        // 'price': priceFormatter(currentSessionDetails.quoteData.qty*currentSessionDetails.quoteData.price),
                                                    },
                                                );
                                            });
                                        }
                                    }
                                    this.signUpForm = false;
                                    this.signInForm = false;
                                    window.location.reload();
                                }
                            }
                        }
                    } catch (err) {
                        console.error(err);
                        this.$snotify.error(err.message, {
                            position: "rightTop",
                            showProgressBar: false,
                        });
                    }
                }
            } catch (error) {
                console.error("Error occured : ", error);
                this.$snotify.error(error.message, {
                    position: "rightTop",
                    showProgressBar: false,
                });
            }
        },
        closeSignInForm() {
            this.signInForm = false;
            this.$store.dispatch("auth/changeRedirectFlag", true);
        },
        closeSignUpForm() {
            this.signUpForm = false;
            this.$store.dispatch("auth/changeRedirectFlag", true);
        },
        openSignInDialog() {
            this.signInForm = true;
            this.signUpForm = false;
        },
        openSignUpDialog() {
            this.signInForm = false;
            this.signUpForm = true;
        },
        builderSession(customizableOptions) {
            let builderSessionOne = null;
            if (customizableOptions && customizableOptions.length > 0) {
                builderSessionOne = customizableOptions.find(
                    (x) => x.label == "BuilderSessionId",
                );
                if (builderSessionOne) {
                    return true;
                }
            }
            return false;
        },
        getAttribute(customAttributes, attributeCode) {
            if (this.productAttributes) {
                let newValue = this.productAttributes.filter((elements) => {
                    return elements.attributeCode === attributeCode;
                });
                if (newValue.length > 0) {
                    let labelValue = newValue[0].options.filter(
                        (elementNew) => {
                            return elementNew.value === customAttributes;
                        },
                    );
                    if (labelValue.length > 0) {
                        return labelValue[0].label;
                    }
                }
            }
        },
        checkThumbnails(personalizeDetails) {
            if (personalizeDetails) {
                let imgCount = 0;
                let i;
                let personalizeDetailsArray = JSON.parse(personalizeDetails);
                for (i = 0; i < personalizeDetailsArray.length; i++) {
                    if (!personalizeDetailsArray[i].thumbnailUrl) imgCount++;
                }
                if (i == imgCount) return false;
                return true;
            }
            return false;
        },
        pageName() {
            return this.$route.name;
        },
        qtyPriceOptions(list, qty, index) {
            this.selectedQty[index] = Number(qty).toString();
            return JSON.parse(list);
        },
        numberOptions: function (baMinSalesQty, baQtyIncrements, qty, index) {
            if (baMinSalesQty && baQtyIncrements) {
                let minSalesQty = baMinSalesQty;
                let qtyIncrements = baQtyIncrements;
                minSalesQty = Number(minSalesQty) ? Number(minSalesQty) : 1;
                qtyIncrements = Number(qtyIncrements)
                    ? Number(qtyIncrements)
                    : 1;

                let nums = [];
                nums[0] = minSalesQty;
                if (qty) {
                    this.selectedQty[index] = Number(qty);
                }
                for (let i = 1; i <= 98; i++) {
                    minSalesQty = minSalesQty + qtyIncrements;
                    nums[i] = minSalesQty;
                }
                if (nums.length > 0) return nums;
                else return "";
            } else {
                return "";
            }
        },
        getCustomAttributeValue(customAttributes, attributeCode) {
            return customAttributeValue(customAttributes, attributeCode);
        },
        getCustomAttributeLable(customAttributes, attributeCode) {
            return getLable(customAttributes, attributeCode);
        },
        gateViewEditCart() {
            this.closeDrawer();
            window.open(`/cart-products/`, "_self");
        },
        closeDrawer() {
            if (this.userAuth) {
                this.$store.dispatch("userCartProduct/cartDrawer", false);
            } else {
                this.$store.dispatch("cartProduct/cartDrawer", false);
            }
            window.open(`${storeFrontUrl}/cart-products/`, "_self");
        },
        goToProductDetails(customAttributes, sku, productType) {
            if (this.userAuth) {
                this.$store.dispatch("userCartProduct/cartDrawer", false);
            } else {
                this.$store.dispatch("cartProduct/cartDrawer", false);
            }
            let productPath = customAttributes.url_key
                ? customAttributes.url_key
                : customAttributeValue(customAttributes, "url_key");
            if (productType == "configurable") {
                window.open(`${storeFrontUrl}/${productPath}`, "_self");
            } else {
                window.open(`${storeFrontUrl}/${productPath}`, "_self");
            }
        },
        remove(sku, itemId, index, builderVersion, product) {
            this.productId = itemId;
            this.productDetails = product;

            let builderSessionOne = this.getBuilderSessionValueFromProduct(
                product.customizableOptions,
            );
            this.removeSessionId =
                builderSessionOne && builderSessionOne.value
                    ? builderSessionOne.value
                    : "";

            this.productBuilderVersion = builderVersion;
            this.userQty = this.selectedQty[index];
            ((this.confirmationDialogFlag = true),
                (this.confirmation = {
                    confirmationMessage:
                        "Are you sure you would like to remove this item from the shopping cart?",
                }));
        },
        async editProduct(
            customAttributes,
            sku,
            itemId,
            index,
            isPersonalize,
            builderVersion,
            ccid,
            productType,
            parentSku,
            product,
        ) {
            if (this.userAuth) {
                this.$store.dispatch("userCartProduct/cartDrawer", false);
            } else {
                this.$store.dispatch("cartProduct/cartDrawer", false);
            }
            if (isPersonalize == "1") {
                if (["2.0", "2.1"].includes(builderVersion)) {
                    let builderSessionOne =
                        this.getBuilderSessionValueFromProduct(
                            product.customizableOptions,
                        );

                    if (builderSessionOne && itemId) {
                        window.removeEventListener(
                            "beforeunload",
                            handleBeforeUnload,
                        );
                        window.open(
                            `${personlizeUrl}/builder/personalize/${builderSessionOne.customizableOptionUid}/session-item/${product.sessionItemId[0]}`,
                            "_self",
                        );
                    }
                } else {
                    let url = `${storeFrontUrl}/crane-connection/${retailorId}/${this.selectedQty[index]}/${sku}/${ccid}/${itemId}`;
                    window.open(url, "_self");
                }
            } else {
                let productPath = customAttributes.url_key
                    ? customAttributes.url_key
                    : customAttributeValue(customAttributes, "url_key");
                this.$emit("actionEditMessage");
                window.open(
                    `${storeFrontUrl}/${productPath}?qty=${this.selectedQty[index]}&itemId=${itemId}`,
                    "_self",
                );
            }
        },
        callsendAppcuesEvent(subTotal) {
            sendAppcuesEvent("priced_sub_total", {
                nature: "personalized",
                personality: "builder",
                currency: "USD",
                price: Number(subTotal),
                sku: this.productSku,
                quantity: this.userQuantity,
            });
        },
        async updateToCart(
            productName,
            sku,
            itemId,
            index,
            price,
            personalizeDetails,
            optionId,
            optionValue,
            productType,
            isPersonalize,
            builderVersion,
            ccid,
            parentSku,
            product,
            event,
        ) {
            const isAuth = this.userAuth;
            const quantity = this.selectedQty[index];
            const optionsList = product?.customizableOptions || [];
            const isBuilder =
                (builderVersion === "2.0" || builderVersion === "2.1") &&
                itemId &&
                price &&
                product;

            const storePrefix = isAuth ? "userCartProduct" : "cartProduct";

            this.$store.commit(`${storePrefix}/cartProductsProgress`, true);

            if (this.pageName() === "CheckoutPage") return;

            try {
                if (isPersonalize === "1") {
                    await this.handlePersonalizedFlow({
                        sku,
                        quantity,
                        itemId,
                        product,
                        optionsList,
                        isBuilder,
                    });
                } else if (
                    productType === "ConfigurableCartItem" &&
                    itemId &&
                    optionId &&
                    optionValue
                ) {
                    await this.handleConfigurableFlow({
                        sku,
                        quantity,
                        itemId,
                        productName,
                        isAuth,
                    });
                } else {
                    await this.handleSimpleFlow({
                        sku,
                        quantity,
                        itemId,
                        productName,
                        isAuth,
                    });
                }
                this.$store.commit(
                    `${storePrefix}/cartProductsProgress`,
                    false,
                );
                this.showSuccess();
            } catch (err) {
                this.$store.commit(
                    `${storePrefix}/cartProductsProgress`,
                    false,
                );
                this.showError(err);
            }
        },
        async handlePersonalizedFlow({
            sku,
            quantity,
            itemId,
            product,
            optionsList,
            isBuilder,
        }) {
            if (isBuilder) {
                const updatedPriceData = await this.getPersonalizedPrice(
                    product,
                    quantity,
                    sku,
                );
                const personalizeIdValue =
                    updatedPriceData?.designProjectId ||
                    updatedPriceData?.sessionId;

                const personalizeId = updatedPriceData?.designProjectId
                    ? "DESIGN_PROJECT_ID"
                    : "BuilderSessionId";

                const action = this.userAuth
                    ? "userCartProduct/updateToPersonalizeCartItem"
                    : "cartProduct/updateToPersonalizeCartItem";

                const resp = await this.$store.dispatch(action, {
                    sku,
                    qty: quantity,
                    orderTotal: updatedPriceData.subTotal,
                    itemId,
                    productOptions: optionsList,
                    routeName: this.$route.name,
                    byType: "label",
                    optionIdType: "customizableOptionUid",
                    perosonalizeIdValue: personalizeIdValue,
                    perosonalizeId: personalizeId,
                });

                if (resp && personalizeId == "BuilderSessionId") {
                    await this.syncBuilderSession(
                        personalizeIdValue,
                        quantity,
                        updatedPriceData.subTotal,
                    );
                }
                return;
            }

            await this.updateCraneCart(sku, quantity, itemId, optionsList);
        },
        async handleConfigurableFlow({
            sku,
            quantity,
            itemId,
            productName,
            isAuth,
        }) {
            await this.updateToCartItem(
                null,
                sku,
                quantity,
                itemId,
                this.$route.name,
                null,
                null,
                isAuth,
            );

            this.redirectAfterUpdate(productName, quantity, itemId);
        },
        async handleSimpleFlow({ sku, quantity, itemId, productName, isAuth }) {
            await this.updateToCartItem(
                null,
                sku,
                quantity,
                itemId,
                this.$route.name,
                null,
                null,
                isAuth,
            );

            this.redirectAfterUpdate(productName, quantity, itemId);
        },
        async updateCraneCart(sku, qty, itemId, optionsList) {
            const craneConnectionOne = optionsList.find(
                (x) => x.label.toLowerCase() === "craneconnectionorderid",
            );

            const ccid = craneConnectionOne?.values?.[0]?.value;

            const action = this.userAuth
                ? "userCartProduct/updateToPersonalizeCartItem"
                : "cartProduct/updateToPersonalizeCartItem";

            return this.$store.dispatch(action, {
                sku,
                qty,
                itemId,
                productOptions: optionsList,
                routeName: this.$route.name,
                byType: "label",
                optionIdType: "customizableOptionUid",
                updateToCC: true,
                perosonalizeIdValue: ccid,
                perosonalizeId: "CraneConnectionOrderId",
            });
        },
        async syncBuilderSession(sessionId, qty, subTotal) {
            let sessionOneDetails = await this.$store.dispatch(
                "sessionOne/fetchOne",
                { sessionId: sessionId },
            );

            sessionOneDetails = sessionOneDetails?.response?.[0];
            if (!sessionOneDetails) return;

            await this.$store.dispatch("sessionOne/updateOne", {
                sessionId: sessionId,
                property: {
                    productData: {
                        ...sessionOneDetails.productData,
                        quantity: qty,
                        productSubTotal: subTotal,
                    },
                    quoteData: {
                        ...sessionOneDetails.quoteData,
                        qty,
                        productSubTotal: subTotal,
                    },
                },
            });
            if (this.builderSessionId == sessionId) {
                window.removeEventListener("beforeunload", handleBeforeUnload);
                window.location.reload();
            }
        },
        showSuccess() {
            this.snackbar = {
                message: "Product Updated Successfully",
                color: "success",
                show: true,
                timeout: 3000,
            };
        },

        showError(err) {
            this.snackbar = {
                message: err?.message || "Something went wrong",
                color: "error",
                show: true,
                timeout: 3000,
            };
            setTimeout(() => {
                this.$emit("actionClose", this.snackbar);
            }, 3000);
        },

        redirectAfterUpdate(productName, qty, itemId) {
            if (this.$route.name === productName && this.$route.query.qty) {
                this.$router.replace({
                    name: productName,
                    query: { qty, itemId },
                });
            }
        },
        async removeProduct(action) {
            // eslint-disable-next-line

            //let token = getAuthUser();

            try {
                this.confirmationDialogFlag = false;
                if (action) {
                    if (this.userAuth) {
                        try {
                            await this.$store.dispatch(
                                "userCartProduct/removeCartProduct",
                                {
                                    productId: this.productId,
                                },
                            );
                            googleAanalyticsEventRemoveCart(
                                "remove_from_cart",
                                this.productDetails,
                            );

                            this.$snotify.success(
                                "Product Removed Successfully",
                                {
                                    position: "rightTop",
                                    showProgressBar: false,
                                },
                            );
                            this.$store.dispatch(
                                "userCartProduct/cartDrawer",
                                false,
                            );
                        } catch (error) {
                            this.$snotify.error(error.message, {
                                position: "rightTop",
                                showProgressBar: false,
                            });
                        }
                    } else {
                        try {
                            await this.$store.dispatch(
                                "cartProduct/removeCartProduct",
                                this.productId,
                                //guestQuoteId: this.guestQuoteId
                            );
                            googleAanalyticsEventRemoveCart(
                                "remove_from_cart",
                                this.productDetails,
                            );
                            this.$snotify.success(
                                "Product Removed Successfully",
                                {
                                    position: "rightTop",
                                    showProgressBar: false,
                                },
                            );

                            this.$store.dispatch(
                                "cartProduct/cartDrawer",
                                false,
                            );
                        } catch (error) {
                            this.$snotify.error(error.message, {
                                position: "rightTop",
                                showProgressBar: false,
                            });
                        }
                    }

                    //this.dialog = false;
                    cookies.remove(
                        this.productId,
                        null,
                        getDomain(window.location.hostname),
                    );
                    try {
                        if (
                            this.removeSessionId &&
                            ["2.0", "2.1"].includes(this.productBuilderVersion)
                        ) {
                            await this.$store.dispatch(
                                "sessionOne/updateOneForCart",
                                {
                                    sessionId: this.removeSessionId,
                                    property: {
                                        quoteData: null,
                                        orderState: null,
                                    },
                                },
                            );
                        }
                    } catch (error) {
                        this.$snotify.error(error.message, {
                            position: "rightTop",
                            showProgressBar: false,
                        });
                    }

                    if (
                        this.removeSessionId == this.builderSessionId &&
                        ["2.0", "2.1"].includes(this.productBuilderVersion)
                    ) {
                        this.$router.push({
                            name: "SessionStart",
                            params: {
                                sku: this.productDetails.sku,
                                quantity: this.userQty,
                            },
                        });
                    }
                }
            } catch (error) {
                console.error(error);
                this.$snotify.error(error, {
                    position: "rightTop",
                    showProgressBar: false,
                });
            }
            this.removeSessionId = "";
            this.productBuilderVersion = "";
            this.confirmation = {
                confirmationMessage: "",
            };
            this.productId = "";
        },
        // goToRoute(sessionId) {
        //   if (sessionId) {
        //     this.$router.push({
        //       name: "SessionResume",
        //       params: {
        //         sessionId: sessionId,
        //       },
        //     });
        //   }
        // },
        getBuilderSessionValueFromProduct(customizableOptions) {
            let builderSessionOne = null;
            if (customizableOptions.length > 0) {
                builderSessionOne = customizableOptions.find(
                    (x) => x.label == "BuilderSessionId",
                );
                return builderSessionOne ? builderSessionOne.values[0] : null;
            }
            return builderSessionOne;
        },
        getDesignProjectIdFromProduct(customizableOptions) {
            let designProjectId = null;
            if (customizableOptions.length > 0) {
                designProjectId = customizableOptions.find(
                    (x) => x.label == "DESIGN_PROJECT_ID",
                );
                return designProjectId ? designProjectId.values[0] : null;
            }
            return designProjectId;
        },
        isDesignProject(customizableOptions) {
            let designProjectId =
                this.getDesignProjectIdFromProduct(customizableOptions);
            if (designProjectId) return true;
            return false;
        },
        async getPersonalizedPrice(product, qty, sku) {
            try {
                let builderSessionItems = [];
                let builderSessionOne = this.getBuilderSessionValueFromProduct(
                    product.customizableOptions,
                );
                let sessionId = null;
                let designProjectId = null;
                if (builderSessionOne) {
                    sessionId = builderSessionOne.value;
                } else {
                    let designerProjectOne = this.getDesignProjectIdFromProduct(
                        product.customizableOptions,
                    );
                    if (designerProjectOne) {
                        designProjectId = designerProjectOne.value;

                        let builderSessions = await this.$store.dispatch(
                            "sessionOne/fetchByDesignProjectId",
                            { designProjectId: designProjectId },
                        );
                        let builderSession =
                            builderSessions.length > 0
                                ? builderSessions[0]
                                : null;
                        sessionId = builderSession.id;
                    }
                }

                if (!sessionId) {
                    this.snackbar = {
                        message: "Error while fetching price",
                        color: "error",
                        show: true,
                        timeout: 3000,
                    };
                    throw "Session id is not present";
                }

                let resp = await this.$store.dispatch(
                    "sessionItemList/fetchList",
                    {
                        sessionId,
                    },
                );
                if (resp && resp.response) {
                    builderSessionItems = resp.response;
                    // for (let r = 0; r < resp.response.length; r++) {
                    //   let item = resp.response[r];
                    //   if (item.summaryData) {
                    //     let parsedJson = JSON.parse(item.summaryData);
                    //     productSummaryDetails.push(parsedJson);
                    //   }
                    // }
                }

                let partPrice = null;
                let subTotal = 0;
                let imagelibProduct = await doFetchProductTags(sku);
                let productPartsObjects = [];
                this.isPromotionApplied = false;
                for (let i = 0; i < builderSessionItems.length; i++) {
                    let productPart = builderSessionItems[i];
                    if (productPart.isSelected) {
                        let { processes, linerObject } =
                            getSessionItemProcessesAndLiner(
                                productPart.summaryData?.currentStructure,
                            );
                        productPartsObjects[i] = {};
                        productPartsObjects[i].partName =
                            productPart.summaryData?.defaultStructure?.name;
                        productPartsObjects[i].processes = processes;
                        productPartsObjects[i].linerObject = linerObject;
                    }
                }
                let response = await checkPromotion({
                    sku: sku,
                    quantity: qty,
                    product: imagelibProduct ? imagelibProduct : {},
                    productPartsObjects: productPartsObjects,
                });
                let priceAdjustmentType = null;
                let priceAdjustmentValue = null;
                if (response) {
                    if (
                        response.exclusiveRules.length !==
                        response.exclusive.length
                    )
                        this.isPromotionApplied = false;
                    else {
                        if (response.appliedRules.length) {
                            this.isPromotionApplied = true;
                            let sortedPromotions = [];
                            for (
                                let i = 0;
                                i < response.appliedRules.length;
                                i++
                            ) {
                                let promotion = response.appliedRules[i];
                                if (promotion.price_adjustment == "fixed") {
                                    sortedPromotions.unshift(promotion);
                                } else {
                                    sortedPromotions.push(promotion);
                                }
                            }
                            //fixed is on top
                            for (let r = 0; r < sortedPromotions.length; r++) {
                                let sortedPromotion = sortedPromotions[r];
                                if (
                                    sortedPromotion.price_adjustment == "fixed"
                                ) {
                                    subTotal =
                                        sortedPromotion.price_adjustment_value;
                                } else if (
                                    sortedPromotion.price_adjustment ==
                                    "bump_amount"
                                ) {
                                    subTotal +=
                                        sortedPromotion.price_adjustment_value;
                                } else if (
                                    sortedPromotion.price_adjustment ==
                                    "discount_percentage"
                                ) {
                                    priceAdjustmentType = "discount_percentage";
                                    priceAdjustmentValue =
                                        sortedPromotion.price_adjustment_value;
                                }
                            }

                            if (subTotal == 0 && !priceAdjustmentType)
                                this.isPromotionApplied = false;
                        } else {
                            this.isPromotionApplied = false;
                        }
                    }
                }

                let { finalPrice } = await this.getSessionItemsFinalPrice(
                    builderSessionItems,
                    qty,
                );

                let pricerSubTotal = finalPrice?.price;

                if (!pricerSubTotal) {
                    throw new Error(
                        "Adjusted price can't be 0. Please refresh and try again.",
                    );
                }

                if (!this.isPromotionApplied) subTotal = pricerSubTotal;
                else if (
                    priceAdjustmentType &&
                    priceAdjustmentType == "discount_percentage"
                ) {
                    if (Number(priceAdjustmentValue)) {
                        subTotal =
                            pricerSubTotal *
                            (1 - Number(priceAdjustmentValue) / 100);
                    }
                }

                return {
                    subTotal: subTotal,
                    personalizeDetails: null,
                    sessionId: sessionId,
                    designProjectId: designProjectId,
                };
            } catch (error) {
                console.log("error", error);
                throw error;
            }
        },
        async getSessionItemsFinalPrice(builderSessionItems, qty) {
            try {
                let basePrice = 0;

                const pricerType = "cloud";
                const pricerOptions = {
                    pricingDateTime: Date.now(),
                    fallbackToOMS: false,
                    compareToOMS: false,
                    audit: [],
                };

                let allElements = getSessionItemCombinedElements({
                    items: builderSessionItems,
                });

                let elementWithHighestColorAddon =
                    getElementWithHighestColorAddon({
                        elements: allElements,
                    });
                console.log(
                    "elementWithHighestColorAddon",
                    elementWithHighestColorAddon,
                );

                const firstColorElement =
                    getFirstColorElement({ elements: allElements }) || {};

                for (let p = 0; p < builderSessionItems.length; p++) {
                    let sessionItemOneDetails = builderSessionItems[p];

                    let currentPartSurfaceType =
                        sessionItemOneDetails.surfaceType;
                    let isAlternateSurface =
                        currentPartSurfaceType == "alternateSurface" || false;

                    if (sessionItemOneDetails.isSelected) {
                        if (!isAlternateSurface) {
                            let structure = await getCurrentItemStructure(
                                sessionItemOneDetails,
                                builderSessionItems,
                            );
                            let maximalStructure;

                            let allPrintableElements = structure.elements
                                .filter(
                                    (currentEle) =>
                                        currentEle.type !== "liner" &&
                                        currentEle.type !== "paper",
                                )
                                .map((currentEle) => ({
                                    ...currentEle,
                                    isOptional: null,
                                    removed: false,
                                }));
                            maximalStructure = assignColorAndPrint({
                                structure: {
                                    ...structure,
                                    elements: allPrintableElements,
                                },
                                print: elementWithHighestColorAddon?.print
                                    ?.name,
                                color: firstColorElement.color,
                            });

                            const productConfiguration = {
                                configuredStructure: maximalStructure,
                                qty: qty,
                            };

                            let pricerResponse = await priceProduct({
                                pricer: pricerType,
                                productConfiguration,
                                options: pricerOptions,
                            });

                            if (pricerResponse?.errors?.length > 0) {
                                throw new Error(
                                    "Error getting price, please contact support team",
                                );
                            }

                            basePrice +=
                                Number(pricerResponse?.currentCloudPrice) || 0;
                        }
                    }
                }
                // }

                if (basePrice == 0) return { finalPrice: 0 };

                let allValidPrintableElements = getAllPrintableElements({
                    elements: allElements,
                });
                let getFinalPriceResponse = getFinalPrice({
                    elements: allValidPrintableElements,
                    basePrice: basePrice,
                    qty
                });
                console.log("getFinalPriceResponse", getFinalPriceResponse);

                return { finalPrice: getFinalPriceResponse };
            } catch (err) {
                console.error("Error while changing quantity ", err);
                this.disableSubmit = true;
                this.isErrorInPrice = true;
            }
        },
        async saveIncident({
            errorObject,
            title,
            description,
            tags,
            sessionId,
            toContinueSession = false,
        }) {
            try {
                await this.$store.dispatch("incidentOne/setOne");
                let userAgent = navigator;

                let currentdate = await isoStringToNormalDate();
                let newErr = null;
                if (
                    errorObject &&
                    errorObject.stack &&
                    errorObject.stack.new_price
                ) {
                    newErr = JSON.stringify(errorObject);
                } else {
                    newErr = JSON.stringify(errorObject.toLocaleString());
                }

                let incidentObj = {
                    title: title,
                    level: "major",
                    description: description,
                    tags: tags && tags.length ? tags : [],
                    recorded_at: currentdate,
                    module: "studio",
                    metadata: {
                        currentSessionId: sessionId,
                        errorStack: JSON.stringify(
                            errorObject.stack || errorObject,
                        ),
                        error: newErr,
                        platform: userAgent.platform,
                        appVersion: userAgent.appVersion,
                        appCodeName: userAgent.appCodeName,
                    },
                };
                let savedIncidentResp = await this.$store.dispatch(
                    "incidentOne/save",
                    {
                        one: incidentObj,
                    },
                );
                console.log("savedIncidentResp", savedIncidentResp);

                let ddErr = new Error(title);
                console.error(ddErr, incidentObj.metadata);
                // if(window.DD_RUM){
                //   window.DD_RUM.onReady(function() {
                //     window.DD_RUM.addError(ddErr,{
                //       module: "studio",
                //       level: "major",
                //       currentSessionId: sessionId,
                //       description,
                //       errorDetails: newErr
                //     });
                //   });
                // } else {
                //   console.log("window.DD_RUM  variable is NOT Available in studio ")
                // }
            } catch (err) {
                console.error(err);
                throw err;
            }
        },
        async updateToCartItem(
            ccid,
            sku,
            qty,
            itemId,
            routeName,
            price,
            personalizeDetails,
            isUser,
            builderVersion,
            sessionId,
        ) {
            try {
                let resp = null;

                if (isUser) {
                    resp = await this.$store.dispatch(
                        "userCartProduct/updateMiniCart",
                        {
                            ccid: ccid,
                            sku: sku,
                            qty: qty,
                            itemId: itemId,
                            routeName: routeName,
                            price: price,
                            personalizeDetails: personalizeDetails,
                        },
                    );
                } else {
                    resp = await this.$store.dispatch(
                        "cartProduct/updateMiniCart",
                        {
                            ccid: ccid,
                            sku: sku,
                            qty: qty,
                            itemId: itemId,
                            routeName: routeName,
                            price: price,
                            personalizeDetails: personalizeDetails,
                        },
                    );
                }

                this.$snotify.success("Product Updated Successfully", {
                    position: "rightTop",
                    showProgressBar: false,
                });
            } catch (error) {
                console.error(error);
                this.$snotify.error(error.message, {
                    position: "rightTop",
                    showProgressBar: false,
                });
            }
        },
    },
    async created() {
        const isAuth = this.userAuth;

        const storePrefix = isAuth ? "userCartProduct" : "cartProduct";
        try {
            this.$store.commit(`${storePrefix}/cartProductsProgress`, true);
            let currentSessionSku = null;
            if (this.sessionOneDetails && this.sessionOneDetails.sku) {
                currentSessionSku = this.sessionOneDetails.productData.sku;
            } else {
                let resp = await this.$store.dispatch(
                    "sessionOne/fetchOneForCart",
                    {
                        sessionId: this.builderSessionId,
                    },
                );
                currentSessionSku = resp.response.productData.sku;
            }
            if (this.cartItems && this.cartItems.length) {
                let skuList = [currentSessionSku];
                for (let p = 0; p < this.cartItems.length; p++) {
                    let product = this.cartItems[p];
                    if (product && product.customizableOptions) {
                        if (this.builderSession(product.customizableOptions))
                            skuList.push(product.product.sku);
                        if (this.isDesignProject(product.customizableOptions))
                            skuList.push(product.product.sku);
                    }
                }

                if (skuList.length) {
                    // pricer bundle loaded

                    window.pricerFieldsIdx = pricerFieldsIdx;
                    let currentDateInIso = new Date().toISOString();
                    let bundleResp = await this.$store.dispatch(
                        "pricerBundleOne/fetchPriceBundle",
                        { skuList: skuList, availableAt: currentDateInIso },
                    );
                    if (bundleResp) {
                        window.pricer = {
                            ...pricerFiles,
                            ...bundleResp,
                        };
                    }
                    console.log(window.pricer);
                }
            }
        } finally {
            this.$store.commit(`${storePrefix}/cartProductsProgress`, false);
        }
    },
};
</script>
<style lang="scss">
.cartproductlist-select-button.v-text-field.v-text-field--enclosed:not(
        .v-text-field--rounded
    )
    > .v-input__control
    > .v-input__slot {
    padding: 0 8px !important;
    min-height: 30px !important;
    max-width: 100px !important;
}
.cartproductlist-select-button .v-input__append-inner {
    padding-bottom: 3px !important;
}
.cartproductlist-select-button .v-select__selection.v-select__selection--comma {
    margin: 0px !important;
}
.cartproductlist-select-button:hover
    .v-select__selection.v-select__selection--comma {
    color: #2850da !important;
}
.cartproductlist-select-button:hover
    .v-input__append-inner
    .v-input__icon
    .v-icon {
    color: #2850da !important;
}
.cartproductlist-expansion .v-expansion-panel-text__wrap {
    padding: 0 0px 0px !important;
}
.custom-panel-title > .v-expansion-panel-title__overlay {
    opacity: 0 !important;
}

.custom-panel-title:hover .v-expansion-panel-title__overlay {
    opacity: 0 !important;
}
.v-expansion-panel--active .v-expansion-panel-title {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    min-height: 41px;
}
.custom-panel-text .v-expansion-panel-text__wrapper {
    padding-left: 0px !important;
}
.delete-title-font {
    font-size: 18px !important;
}
.cartproductlist-select-button .v-field.v-field:hover {
    color: #3d5789 !important;
}
.cartproductlist-select-button .v-field .v-select--active-menu {
    border: 2px solid red !important;
}
.cartproductlist-select-button .v-field .v-field-focused {
    border: 2px solid red !important;
}
.cartproductlist-expansion .v-expansion-panel-content__wrap {
    padding: 0 0px 0px !important;
}
.prod-view-dialog {
    min-height: calc(100vh - 20px); // to adjust you can change 180px
}
.active-panel-edited .v-expansion-panel-title__overlay {
    background-color: transparent !important;
}

.border-left-none {
    border-left: none !important;
}
</style>
<style src="./CartProductList.scss" lang="scss" scoped />
